<template>
  <div>
    <div class="form-group">
      <label class="control-label">Agency</label>
      <multiselect
        :value="agencySelected"
        :options="agencies"
        track-by="id"
        placeholder
        label="name"
        :show-labels="false"
        @input="handleSelectAgencyCallback"
        :searchable="false"
        :preselect-first="true"
        :allow-empty="false"
      />
    </div><!-- /.form-group -->

    <div class="card">
      <ul class="list-data">
        <li class="data-heading d-none d-xl-block">
          <div class="row">
            <div class="col">
              <p>Graduate</p>
            </div>
            <div class="col-auto">
              <p>GEN</p>
            </div>
          </div><!-- /.row -->
        </li>
        <graduates-list-item v-for="graduate in graduates" :graduate="graduate" :key="graduate.id"/>
      </ul><!-- /.list-data -->
    </div><!-- /.card -->
  </div>
</template>
<script>
import { programComputed, programGraduateComputed, programGraduateMethods, agencyComputed, agencyMethods } from 'vx/helpers'
import { appliesFilters } from 'mixins'
import { helpers } from 'mixins/programs'
import { merge, head } from 'lodash'
import GraduatesListItem from './ProgramsSingleGraduatesCoordinatorListItem'
import Multiselect from 'vue-multiselect'

export default {
  mixins: [appliesFilters, helpers],

  components: {
    GraduatesListItem,
    Multiselect
  },

  data () {
    return {
      filtersDebounced: false,
      fetching: false,
      filters: {
        agency: null
      },
      agencySelected: null
    }
  },

  computed: {
    ...programComputed,
    ...programGraduateComputed,
    ...agencyComputed,

    noGraduates () {
      return this.graduates.length === 0
    }
  },

  watch: {
    queryParams: {
      async handler (params) {
        this.fetching = true

        await this.getGraduates({ params: merge(params, { 'placement': this.programFindPlacement(1).id }) })

        this.fetching = false

        this.$nextTick(() => {
          if (this.$refs.lazy) {
            this.$refs.lazy.$emit('reset')
          }
        })
      },
      immediate: true
    }
  },

  async created () {
    await this.getAgencies({ 'enabled': 'true' })

    this.agencySelected = this.agencies.find(agency => agency.id === parseInt(this.$route.query.agency)) || head(this.agencies)

    this.filters.agency = this.agencySelected ? this.agencySelected.id : null
  },

  beforeDestroy () {
    this.resetGraduates()
  },

  methods: {
    ...programGraduateMethods,
    ...agencyMethods,

    async handleGetNextGraduatesCallback () {
      await this.getGraduates({ params: merge(this.queryParams, { 'placement': this.programFindPlacement(1).id }), next: true })

      this.$refs.lazy.$emit('reset')
    },

    handleSelectAgencyCallback (agency) {
      this.agencySelected = agency

      this.filters.agency = agency ? agency.id : null
    }
  }
}
</script>
